var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import { Prop } from "vue-property-decorator";
var letterAccModule = namespace("letter-acc");
var LetterTempOne = /** @class */ (function (_super) {
    __extends(LetterTempOne, _super);
    function LetterTempOne() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.sd = 'none'; // 展示模板的div默认不显示
        _this.printDataNoShow = '1.0'; // 默认显示
        _this.noShowUnline = '1px'; // 默认显示元素下边框
        return _this;
    }
    LetterTempOne.prototype.mounted = function () {
    };
    LetterTempOne.prototype.activated = function () {
    };
    /**
      * 信函模板tab页激活时使使展示模板的div显示
     */
    LetterTempOne.prototype.ltShowTemp = function () {
        this.sd = 'block';
    };
    __decorate([
        Prop()
    ], LetterTempOne.prototype, "printDataArr", void 0);
    __decorate([
        Prop()
    ], LetterTempOne.prototype, "PrintInfo", void 0);
    __decorate([
        letterAccModule.State
    ], LetterTempOne.prototype, "browserType", void 0);
    __decorate([
        letterAccModule.State
    ], LetterTempOne.prototype, "someSymbol", void 0);
    __decorate([
        letterAccModule.State
    ], LetterTempOne.prototype, "ymdDate", void 0);
    LetterTempOne = __decorate([
        Component({
            components: {}
        })
    ], LetterTempOne);
    return LetterTempOne;
}(Vue));
export default LetterTempOne;
